import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  permitKeys,
  RequestTypes,
} from '@core/react-query/features/permits/permit'
import { IPermit } from '@core/entities/permit/Permit'
import { useMutateQueryData } from '@core/react-query/hooks'
import { permitsKeys } from '@core/react-query/features/permits'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const getRequestPermitMutationOptions = (queryClient: QueryClient) => {
  const { updateInfiniteQueryItem, deleteInfiniteQueryItem } =
    useMutateQueryData(queryClient)
  return {
    ...permitKeys.request,
    onSuccess: (permit, variables) => {
      // 427 idempotent replay: the permit was created by an earlier attempt and
      // the response carries no body, so refetch the lists instead of patching.
      if (!permit?.id || !permit.project?.id) {
        queryClient.invalidateQueries({ queryKey: permitsKeys.allPermits._def })
        if (variables.draftId) {
          queryClient.invalidateQueries({ queryKey: permitsKeys.drafts._def })
        }
        return
      }
      queryClient.setQueryData(
        permitKeys.byId({ permitId: permit.id }).queryKey,
        permit,
      )
      if (variables.draftId) {
        deleteInfiniteQueryItem(
          permitsKeys.drafts({
            organisationId: permit.organisationId,
            projectIds: [permit.project.id],
          }).queryKey,
          variables.draftId,
        )
      }
      updateInfiniteQueryItem(
        permitsKeys
          .allPermits({
            organisationId: permit.organisationId,
            projectIds: [permit.project.id],
          })
          .queryKey.slice(0, -3),
        permit,
      )
    },
  }
}

export const useRequestPermit = () => {
  const queryClient = useQueryClient()
  return useMutation<IPermit, RequestErrorType, RequestTypes['request']>(
    getRequestPermitMutationOptions(queryClient),
  )
}
